import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, PlainButton } from '@bos/ui';
import { closeSnackbar } from 'notistack';
export const SnackbarCloseIcon = ({ snackbarId }) => {
    const handleCloseSnackbar = () => {
        closeSnackbar(snackbarId);
    };
    return (_jsx(PlainButton, { type: 'button', onClick: handleCloseSnackbar, children: _jsx(Icon, { name: 'Close', size: 'medium', color: 'white' }) }));
};
